module.exports = __webpack_public_path__ + "media/images/v1/banner_square-f1d5a29e22bb180b310179fda35f78ee.jpg";